// 会员商品code
export const COMPANY_GOOD_CODE = "huabanqiyevip";
export const PERSONAL_GOOD_CODE = "huabangerenvip";
/**
 * 会员下载权益code
 *  */
export const VIP_RIGHT_IDENTIFICATION = "HUABAN_SUCAI";

// 权益包标识 用于权益列表中判断权益类型是什么
// 使用场景：限制24小时加油包权益只能小于10个
export const PERSONAL_UPGRADE = "HUABAN_SUCAI_PERSON_DOWNLOAD"; // 个人升级包权益包标识
export const PERSONAL_TEMPORARY = "HUABAN_SUCAI_PERSON_TEMPORARYDOWNLOAD"; // 个人加油包权益包标识
export const COMPANY_UPGRADE = "HUABAN_SUCAI_ENTERPRISE_DOWNLOAD"; // 企业升级包权益包标识
export const COMPANY_UPGRADE_PLUS = "HUABAN_SUCAI_ENTERPRISE_DOWNLOAD_2"; // 企业升级包加强版 +40
export const COMPANY_TEMPORARY = "HUABAN_SUCAI_ENTERPRISE_TEMPORARYDOWNLOAD"; // 企业加油包权益包标识
export const EXTEND_AUTH = "HUABAN_SUCAI_ADVANCED_AUTHORIZAYTION"; // 企业扩展授权
// 大会员下载权益包code
export const BIG_COMPANY_DOWNLOAD_PAKGCODES = [
  "HUABAN_SUCAI_LARGEBUSINESS_DOWNLOAD", //下载+100
];
/**个人无商用授权 */
export const PERSONAL_NO_AUTH = "HUABAN_PERSON_NO_AUTH";

/**
 * 扩展权益权益包code集合
 */
export const RIGHT_PACKAGE_CODE = {
  PERSONAL_UPGRADE,
  PERSONAL_TEMPORARY,
  COMPANY_UPGRADE,
  COMPANY_TEMPORARY,
  EXTEND_AUTH,
};
// 升级包
export const UPGRADE_RIGHT_PACKAGE_CODES = [PERSONAL_UPGRADE, COMPANY_UPGRADE];

export const UPGRADE_RIGHT_PLUS_PACKAGE_CODES = [COMPANY_UPGRADE_PLUS];
// 24H加油包
export const TEM_RIGHT_PACKAGE_CODES = [PERSONAL_TEMPORARY, COMPANY_TEMPORARY];
// 扩展授权包
export const AUTH_RIGHT_PACKAGE_CODES = [EXTEND_AUTH];

const prodConf = {
  HBCategoryId: [208, 196, 195, 194, 182, 181, 255, 258].join(","), //HB分类id
  rightCode: VIP_RIGHT_IDENTIFICATION, //会员下载权益
  company: {
    title: "企业VIP",
    goodCode: COMPANY_GOOD_CODE,
    vipId: 156,
    // 扩展包商品code
    pkgCode: {
      update: COMPANY_UPGRADE,
      updatePlus: COMPANY_UPGRADE_PLUS,
      authExtend: EXTEND_AUTH,
      temporary: COMPANY_TEMPORARY,
    },
    pkgGoodCode: {
      update: "huabanqiyevipshengjiall",
      updatePlus: "huabanqiyevipshengjiall2",
      authExtend: "huabanqiyegaojiall",
      temporary: "huabanqiyevipjiayouall",
    },
  },
  personal: {
    title: "个人VIP",
    goodCode: PERSONAL_GOOD_CODE,
    vipId: 155,
    pkgCode: {
      update: PERSONAL_UPGRADE,
      temporary: PERSONAL_TEMPORARY,
    },
    pkgGoodCode: {
      update: "huabangerenvipshengjiall",
      temporary: "huabangerenvipjiayouall",
    },
  },
  bigCompany: {
    vipId: 166,
  },
  payUrl: "https://huaban.com",
};

// 稿定类目分类
const VIP_CONF = {
  dev: {
    HBCategoryId: 268, //HB分类id
    rightCode: VIP_RIGHT_IDENTIFICATION, //会员下载权益
    company: {
      title: "企业VIP",
      goodCode: COMPANY_GOOD_CODE,
      vipId: 161,
      // 扩展包商品权益code
      pkgCode: {
        update: COMPANY_UPGRADE,
        updatePlus: COMPANY_UPGRADE_PLUS,
        authExtend: EXTEND_AUTH,
        temporary: COMPANY_TEMPORARY,
      },
      pkgGoodCode: {
        update: "huabanqiyevipshengjiall",
        updatePlus: "huabanqiyevipshengjiall2",
        authExtend: "huabanqiyegaojiall",
        temporary: "huabanqiyevipjiayouall",
      },
    },
    personal: {
      title: "个人VIP",
      goodCode: PERSONAL_GOOD_CODE,
      vipId: 160,
      pkgCode: {
        update: PERSONAL_UPGRADE,
        temporary: PERSONAL_TEMPORARY,
      },
      pkgGoodCode: {
        update: "huabangerenvipshengjiall",
        temporary: "huabangerenvipjiayouall",
      },
    },
    bigCompany: {
      vipId: 171,
    },
    payUrl: "https://dev.huaban.com",
  },
  fat: {
    HBCategoryId: 215, //HB分类id
    rightCode: VIP_RIGHT_IDENTIFICATION, //会员下载权益
    company: {
      title: "企业VIP",
      goodCode: COMPANY_GOOD_CODE,
      vipId: 226,
      // 扩展包商品code
      pkgCode: {
        update: COMPANY_UPGRADE,
        updatePlus: COMPANY_UPGRADE_PLUS,
        authExtend: EXTEND_AUTH,
        temporary: COMPANY_TEMPORARY,
      },
      pkgGoodCode: {
        update: "huabanqiyevipshengjiall",
        updatePlus: "huabanqiyevipshengjiall2",
        authExtend: "huabanqiyegaojiall",
        temporary: "huabanqiyevipjiayouall",
      },
    },
    personal: {
      title: "个人VIP",
      goodCode: PERSONAL_GOOD_CODE,
      vipId: 225,
      pkgCode: {
        update: PERSONAL_UPGRADE,
        temporary: PERSONAL_TEMPORARY,
      },
      pkgGoodCode: {
        update: "huabangerenvipshengjiall",
        temporary: "huabangerenvipjiayouall",
      },
    },
    bigCompany: {
      vipId: 245,
      code: "bigCompany",
    },
    payUrl: "https://fat.huaban.com",
  },
  stage: {
    ...prodConf,
    payUrl: "https://stage.huaban.com",
  },
  prod: prodConf,
};

export const VIP_CONFIG =
  VIP_CONF[process.env.NEXT_PUBLIC_DEPLOY_ENV || "prod"];

// 一般用于判断商品是什么会员类型
export const isCompanyVip = (vipId) => vipId == VIP_CONFIG.company.vipId;
export const isPersonalVip = (vipId) => vipId == VIP_CONFIG.personal.vipId;
export function getVipTypeById(vipId) {
  if (isPersonalVip(vipId)) return "personal";
  if (isCompanyVip(vipId)) return "company";
}

// 判断大企业订单，主要用于隐藏订单的继续支付按钮
export function isBigCompanyOrder(order) {
  return (
    order.skus.find(
      (sku) => sku?.ref_body?.goods?.vip_id == VIP_CONFIG.bigCompany.vipId
    ) || order.skus.find((sku) => (sku?.ref_body.name || "").includes("大企业"))
  );
}

const isNotExpire = (user) => user?.extra?.material_vip_expire_at > Date.now();

// 一般用于判断当前用户是什么会员类型
export const isBigCompanyByUser = (user) =>
  user?.extra?.material_vip == 30 && isNotExpire(user);
export const isCompanyVipByUser = (user) =>
  user?.extra?.material_vip == 20 && isNotExpire(user);
export const isPersonalVipByUser = (user) =>
  user?.extra?.material_vip == 10 && isNotExpire(user);
export const isExperienceVipByUser = (user) =>
  user?.extra?.material_vip == 5 && isNotExpire(user);

export const isSingleVipByUser = (user) => {
  return user?.extra?.material_vip == 7 && isNotExpire(user);
};

export const isNoAuthByUser = (user) => {
  return user?.extra?.material_vip_auth == 0;
};

export function getVipTypeByUser(user) {
  if (user?.extra?.material_vip && isNotExpire(user)) {
    switch (user.extra.material_vip) {
      case 5:
        // 体验会员
        return "experience";
      case 7:
        // 单品类无商用授权会员
        if (user.extra?.material_vip_auth === 0) {
          return "singleNoAuth";
        }
        // 单品类会员
        return "single";
      case 10:
        // 个人会员
        return "personal";
      case 20:
        // 企业会员
        return "company";
      case 30:
        // 大企业会员
        return "bigCompany";
      default:
        return "no";
    }
  }
  return "no";
}

/**黑底白字会员标识 */
export const vipTag = {
  company: "https://st0.dancf.com/static/02/202311220706-8a04.svg",
  personal: "https://st0.dancf.com/static/02/202311220706-bf97.svg",
  experience: "https://st0.dancf.com/static/02/202205100357-0dfb.svg",
  no: "https://st0.dancf.com/static/02/202205100328-b1ee.svg",
  bigCompany: "https://st0.dancf.com/static/02/202208020156-ff59.svg",
  singleNoAuth: "https://st0.dancf.com/static/02/202311220706-0ab2.svg",
  single: "https://st0.dancf.com/static/02/202311280242-92ce.svg",
};

export const VipTitleMap = {
  single: "商用模板VIP",
  company: "企业全站VIP",
  personal: "个人全站VIP",
  experience: "体验VIP",
  no: "",
  bigCompany: "大企业VIP",
  singleNoAuth: "模板VIP",
};

/**
 *
 * @param {IUser} user
 * @returns {"企业VIP" | "个人VIP" | "体验VIP" | "" | "大企业VIP}
 */
export function getVipTitleByUser(user) {
  const vipType = getVipTypeByUser(user);
  return VipTitleMap[vipType];
}

/**
 *
 * @param {IUser} user
 * @returns
 */
export function isVipByUser(user) {
  return user?.extra?.material_vip > 0 && isNotExpire(user);
}
